import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQuerySavedVariationArgs, BackendSavedVariation } from 'src/types/backend';

const QUERY = gql`
  query SavedVariation($id: ID!) {
    savedVariation(id: $id) {
      id
      text
      score
    }
  }
`;

type Variables = BackendQuerySavedVariationArgs;
type Result = Pick<BackendSavedVariation, 'id' | 'text' | 'score'>;

export const querySavedVariationOriginalText = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });

  const data = getSingleProp<Result>(result.data);
  if (!data) {
    return null;
  }
  return {
    text: data.text,
    score: data.score,
  };
};
